import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ShortageCommentsService {
  private apiUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_COMMENTS}`;

  constructor(private http: HttpClient) { }

  getCommentsData(email: string): Observable<any> {
    return this.http.get(`${this.apiUrl}?user_email=${email}`);
  }
}
